(() => {
  const init = root => {
    root.querySelectorAll('[data-about-editorial]').forEach(page => {
      if(page.dataset.aboutReady) return;
      page.dataset.aboutReady='true';
      const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      if(motion.matches || !('IntersectionObserver' in window)) return;
      const elements=[...page.querySelectorAll('[data-about-reveal]')];
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.remove('about-will-reveal');observer.unobserve(entry.target);}
      }),{threshold:.08});
      elements.forEach(element=>{
        if(element.getBoundingClientRect().top>window.innerHeight){element.classList.add('about-will-reveal');observer.observe(element);}
      });
      motion.addEventListener('change',()=>{observer.disconnect();elements.forEach(element=>element.classList.remove('about-will-reveal'));},{once:true});
      page.addEventListener('focusin',event=>event.target.closest('[data-about-reveal]')?.classList.remove('about-will-reveal'));
    });
  };
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
